var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessanger = function SvgMessanger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 2C6.36625 2 2 6.12681 2 11.7003C2 14.6159 3.19519 17.135 5.14089 18.8755C5.30386 19.0224 5.40246 19.2256 5.41051 19.4449L5.46483 21.2236C5.48294 21.791 6.06846 22.1592 6.58758 21.9318L8.57151 21.0566C8.74053 20.9821 8.92765 20.968 9.10472 21.0163C10.0162 21.2679 10.988 21.4007 12.0001 21.4007C17.634 21.4007 22.0003 17.2738 22.0003 11.7003C22.0003 6.12681 17.634 2 12.0001 2Z",
    fill: "url(#paint0_linear_1855_6654)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99587 14.5375L8.93354 9.87747C9.40034 9.13702 10.4024 8.95191 11.1026 9.47706L13.4386 11.2296C13.6539 11.3906 13.9477 11.3886 14.161 11.2276L17.3159 8.83319C17.7365 8.51327 18.2878 9.01831 18.0041 9.46499L15.0684 14.123C14.6016 14.8635 13.5996 15.0486 12.8994 14.5234L10.5633 12.7709C10.348 12.6099 10.0543 12.6119 9.84099 12.7729L6.68401 15.1693C6.26348 15.4892 5.71217 14.9842 5.99587 14.5375Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1855_6654",
    x1: 12.0001,
    y1: 2,
    x2: 12.0001,
    y2: 22.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006AFF"
  })))));
};
export default SvgMessanger;